export const toggleSidebarState = (
  { event } = { event: undefined },
) => state => {
  event.stopPropagation();

  return {
    ...state,
    sidebar: {
      ...state.sidebar,
      active: !state.sidebar.active,
    },
  };
};
